
import { Card, CardContent } from "@/components/ui/card";
import { motion } from "framer-motion";
import { Users, Shuffle } from "lucide-react";
import { PartnerLogos } from "./PartnerLogos";
import PartnerLogoUploader from "../admin/PartnerLogoUploader";
import { useIsMobile } from "@/hooks/use-mobile";

const AboutSection = () => {
  const container = {
    hidden: {
      opacity: 0
    },
    show: {
      opacity: 1,
      transition: {
        staggerChildren: 0.1
      }
    }
  };

  return <section className="py-12 md:py-24 relative overflow-hidden">
      <div className="absolute top-0 left-0 w-full h-60 bg-gradient-to-b from-secondary/20 to-transparent pointer-events-none"></div>
      <div className="absolute bottom-0 right-0 w-60 h-60 bg-primary/5 rounded-full blur-3xl pointer-events-none"></div>
      
      <div className="container mx-auto px-4 relative z-10">
        <motion.div className="text-center mb-8 md:mb-16" initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6
      }} viewport={{
        once: true,
        margin: "-100px"
      }}>
          <h2 className="text-3xl md:text-4xl font-bold mb-4 bg-clip-text text-transparent bg-gradient-to-r from-primary to-primary/70">
            Rejoins la Creator Academy : ta carrière de créateur commence ici !
          </h2>
          
        </motion.div>
        
        <div className="grid grid-cols-1 lg:grid-cols-3 gap-6 md:gap-12 lg:gap-20 items-start">
          <motion.div className="col-span-1 lg:col-span-2 space-y-4 md:space-y-6" initial={{
          opacity: 0,
          x: -30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} transition={{
          duration: 0.8
        }} viewport={{
          once: true,
          margin: "-100px"
        }}>
            <Card className="bg-background/80 backdrop-blur-md border border-primary/20 shadow-lg hover:shadow-xl transition-all duration-300 overflow-hidden">
              <CardContent className="p-4 sm:p-6 md:p-10">
                <p className="text-sm sm:text-base md:text-lg leading-relaxed text-foreground">
                  La Creator Academy est un collectif innovant réunissant les créateurs de contenus et les professionnels du cinéma et de l'audiovisuel. Ensemble, nous inventons de nouvelles façons de promouvoir et de monétiser les œuvres culturelles, tout en garantissant un cadre légal clair et équitable.
                </p>
                <div className="mt-3 md:mt-6">
                  <p className="text-sm sm:text-base md:text-lg leading-relaxed text-foreground mb-2 md:mb-3">
                    Ici, tu trouveras :
                  </p>
                  <ul className="space-y-1 md:space-y-1.5 text-sm sm:text-base md:text-lg leading-relaxed text-foreground">
                    <li className="flex items-start">
                      <span className="text-primary mr-2">•</span>
                      <span>Un cadre juridique sécurisé et équitable.</span>
                    </li>
                    <li className="flex items-start">
                      <span className="text-primary mr-2">•</span>
                      <span>Des modèles économiques innovants (CPM, CPA, vente de vidéos dérivées).</span>
                    </li>
                    <li className="flex items-start">
                      <span className="text-primary mr-2">•</span>
                      <span>Une communauté active d'entraide et d'expertise.</span>
                    </li>
                  </ul>
                  <p className="text-sm sm:text-base md:text-lg font-semibold text-primary mt-3 md:mt-6">
                    Passe au niveau supérieur avec ReCut !
                  </p>
                </div>
              </CardContent>
            </Card>
          </motion.div>
          
          <motion.div className="relative col-span-1" initial={{
          opacity: 0,
          x: 30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} transition={{
          duration: 0.8
        }} viewport={{
          once: true,
          margin: "-100px"
        }}>
            <div className="absolute -top-10 -left-10 w-20 h-20 bg-primary/10 rounded-full blur-xl"></div>
            <div className="absolute -bottom-10 -right-10 w-20 h-20 bg-secondary/10 rounded-full blur-xl"></div>
            
            <Card className="overflow-hidden bg-background/60 backdrop-blur-md border border-primary/20 shadow-lg">
              <CardContent className="p-4 sm:p-6 md:p-8 lg:p-10">
                <div className="flex items-center justify-center mb-4 sm:mb-6 md:mb-8">
                  <Users className="h-5 w-5 sm:h-6 sm:w-6 md:h-7 md:w-7 text-primary mr-2" />
                  <h3 className="text-lg sm:text-xl md:text-2xl font-bold">15+ créateurs</h3>
                </div>
                
                <PartnerLogos fallbackToStaticLogos={true} />
                
              </CardContent>
            </Card>
            
            {/* Only visible to admin users */}
            <PartnerLogoUploader />
          </motion.div>
        </div>
      </div>
    </section>;
};

export default AboutSection;
